import { render } from "./Schutzgerueste.vue?vue&type=template&id=0ec1a346&scoped=true&ts=true"
import script from "./Schutzgerueste.vue?vue&type=script&lang=ts"
export * from "./Schutzgerueste.vue?vue&type=script&lang=ts"

import "./Schutzgerueste.vue?vue&type=style&index=0&id=0ec1a346&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ec1a346"]])

export default __exports__